exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "gh-page-content>.flex-column{width:60%}gh-page-content .street{width:calc(70% - 60px)}gh-page-content .memo{width:100%;padding-right:10px}.flex-row.site{justify-content:space-between}.flex-row.site .form-column{width:calc(33% - 5px)}.flex-row.site .form-column .mat-form-field.field{max-width:100%;min-width:auto}.flex-row.details{justify-content:space-between}.flex-row.details>.flex-column{width:calc(50% - 50px)}.flex-row.details>.flex-column .mat-form-field.field{max-width:100%;min-width:auto}", ""]);

// exports
